import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'
import SortedTablePlugin from "vue-sorted-table"
import moment from 'moment'

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default {
  components: {
    DatePicker,
    vSelect,
  },
  data: function () {
    return {
      busy: false,
      loading: false,
      role: '',
      apiStatus: 'กรุณาระบุเงื่อนไขและกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล',
      // คอลัมน์ชุดเดียวกับไฟล์ Excel — 1 แถว = 1 ม้วน (มีคอลัมน์สาขา)
      fields: [
        { key: 'index', label: '#', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'branch_name', label: 'สาขา', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'document_no', label: 'เลขที่เอกสาร', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'document_date', label: 'วันที่เอกสาร', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'received_date', label: 'วันที่รับม้วน', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'lot_no', label: 'LOT', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'brand', label: 'ยี่ห้อ', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'coil', label: 'Coil No.', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'size', label: 'SIZE', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'color', label: 'COLOR', sortable: true, thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'net_weight', label: 'NET WEIGHT', sortable: true, thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'length', label: 'LENGTH', sortable: true, thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'kg_per_m', label: 'Kg/m', sortable: true, thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'price', label: 'ราคาทุน/หน่วย', sortable: true, thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'value', label: 'มูลค่าทุน', sortable: true, thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'sale_price', label: 'ราคาขายสาขา/หน่วย', sortable: true, thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'sale_value', label: 'มูลค่าขายสาขา', sortable: true, thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
      ],
      items: [],      // summary_by_branch
      details: [],    // รายม้วนทั้งหมด (แบ่งตามสาขาตอนกาง)
      totals: {
        roll_count: 0,
        total_weight: 0,
        total_value: 0,
      },
      options: {
        branches: [],
        brands: [],
        colors: [],
        thicknesses: [],
      },
      filters: {
        start_date: new Date(moment().startOf('month').format('YYYY-MM-DD')),
        end_date: new Date(moment().endOf('month').format('YYYY-MM-DD')),
        branch_ids: [],
        brands: [],
        colors: [],
        thicknesses: [],
      },
    }
  },
  computed: {
    // จำนวนม้วนที่แสดงในตาราง
    rows() {
      return this.details.length
    },
    // ราคาต้นทุนม้วนเห็นได้เฉพาะ Admin กับ ผจก.สาขา (ตรงกับ ChinaOrderModel::canSeeCostPrice)
    // backend ตัดค่าออกให้อยู่แล้ว — ตรงนี้ซ่อนคอลัมน์ไม่ให้เหลือหัวตารางเปล่า
    canSeeCost() {
      return ['Admin', 'Branch Admin'].includes(this.role)
    },
    tableFields() {
      if (this.canSeeCost) return this.fields
      return this.fields.filter((f) => !['price', 'value'].includes(f.key))
    },
  },
  methods: {
    async getRole() {
      try {
        const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
        this.role = res.data.role
      } catch (e) {
        this.role = ''
      }
    },
    // ป้ายบอกจำนวนที่เลือกข้างชื่อฟิลเตอร์ (ว่าง = ทั้งหมด)
    selectedLabel(list) {
      const n = (list || []).length
      return n ? `(เลือก ${n})` : '(ทั้งหมด)'
    },
    // ทศนิยมยืดหยุ่น (Kg/m ต้องละเอียดกว่า 2 ตำแหน่ง)
    formatDecimal(value, digits = 4) {
      return parseFloat(value || 0).toLocaleString('th-TH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: digits,
      })
    },
    // จำนวนม้วนเป็นจำนวนเต็ม — formatCurrency ใน mixin บังคับ 2 ตำแหน่งเสมอ
    formatNumber(value) {
      return parseFloat(value || 0).toLocaleString('th-TH', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    },
    // multi-select → query string แบบ brands[]=a&brands[]=b
    buildQuery() {
      const params = new URLSearchParams()
      params.append('keyword_startdate', moment(this.filters.start_date).format('YYYY-MM-DD'))
      params.append('keyword_enddate', moment(this.filters.end_date).format('YYYY-MM-DD'))

      const multi = {
        'branch_ids[]': this.filters.branch_ids,
        'brands[]': this.filters.brands,
        'colors[]': this.filters.colors,
        'thicknesses[]': this.filters.thicknesses,
      }
      Object.keys(multi).forEach((key) => {
        (multi[key] || []).forEach((v) => {
          if (v !== null && v !== undefined && v !== '') params.append(key, v)
        })
      })

      return params.toString()
    },
    async onLoadOptions() {
      try {
        const res = await this.$axios.get(this.$host + "/api/v1/report/roll-purchase/options")
        const data = res.data || {}
        this.options.branches = data.branches || []
        this.options.brands = data.brands || []
        this.options.colors = data.colors || []
        this.options.thicknesses = data.thicknesses || []
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || 'ไม่สามารถโหลดตัวเลือกตัวกรองได้')
      }
    },
    async onInitData() {
      try {
        this.items = []
        this.details = []
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const res = await this.$axios.get(
          this.$host + "/api/v1/report/roll-purchase?" + this.buildQuery()
        )
        const data = res.data || {}

        this.items = data.summary_by_branch || []
        this.details = data.items || []
        this.totals = data.totals || { roll_count: 0, total_weight: 0, total_value: 0 }

        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler(error?.response?.data?.message || 'ไม่สามารถค้นหาข้อมูลได้')
      }
    },
    onClearFilters() {
      this.filters.branch_ids = []
      this.filters.brands = []
      this.filters.colors = []
      this.filters.thicknesses = []
    },
    async exportExcelReport() {
      try {
        this.loading = true

        const response = await this.$axios.get(
          this.$host + "/api/v1/report/excel/roll-purchase?" + this.buildQuery(),
          { responseType: 'blob' }
        )

        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
        const link = document.createElement('a')
        link.href = url

        const dateOpt = { year: 'numeric', month: 'short', day: 'numeric' }
        link.setAttribute(
          'download',
          this.filters.start_date.toLocaleDateString('th-TH', dateOpt)
          + ' ถึง ' + this.filters.end_date.toLocaleDateString('th-TH', dateOpt)
          + ' รายงานการซื้อม้วนของสาขา.xlsx'
        )

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || 'An error occurred while downloading the file.')
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    await this.getRole()
    await this.onLoadOptions()
  }
}
